import React from "react";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";

const DSDialog = (props: React.ComponentProps<typeof Dialog>) => {
  const { breakpoints } = useTheme();
  const isPhone = useMediaQuery(breakpoints.down("sm"));

  // Large record dialogs (md and up) take the whole screen on phones;
  // small confirms keep floating. An explicit fullScreen prop always wins.
  const isLargeDialog =
    props.maxWidth === "md" ||
    props.maxWidth === "lg" ||
    props.maxWidth === "xl";
  const fullScreen = props.fullScreen ?? (isPhone && isLargeDialog);

  // Some hosts pass low zIndex hacks (zIndex: 1) that sit below the fixed
  // app bar — fine for centered dialogs, broken in fullscreen. Force the
  // modal layer whenever fullscreen is active.
  const sx = fullScreen
    ? [
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        {
          zIndex: (theme: { zIndex: { modal: number } }) => theme.zIndex.modal,
        },
      ]
    : props.sx;

  return <Dialog {...props} fullScreen={fullScreen} sx={sx} />;
};

export default DSDialog;
